import api from "@/services/api.service";
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'add',
  components: {},
  props: {      
  },
  data () {
    return {
      caption:"Assign Vendor",
      vendors:[],
      formField:{tags:[],user_id:'',contact_values:{},type:""},
      submitStatus: null,
      filterCriteria:[{columns:null,text_value:null}],
      //filterCriteriaColumns :[],
      map_headers: [],        
      concateColumn:[{name:null,columns:[null]}],
      selectedHeadersShow:[],
      existing_tags:[],
      permission_add: false,
      superAdmin: false      
    }
  },
  computed: {    
  },
  mounted () {

  },
  validations: {
    formField: {            
      user_id:{
        required
      },
      type: {
        required
      },
      tags: {
        required
      }
    }
  },
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        response.data[0].permission.forEach( function(element) {                
          permissions.push(element.action)
        }.bind(this));
        if(permissions.includes("add_vendor_event") == true ){
            this.getVendors();
            this.getColumns();
            this.getTags();
            this.permission_add = permissions.includes("add_vendor_event");
          }else if(response.data[0].role == 'super_admin'){
            this.getVendors();
            this.getColumns();
            this.getTags(); 
            this.superAdmin = true;
          }else if(permissions.includes("list_event") == true || permissions.includes("add_event") == true){
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'List Event'});
          }else{
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'Admin Dashboard'});
          }
  },  
  methods: {
    makeToast(message = '',title='Alert',variant='warning') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title:title,
        variant:variant,
        autoHideDelay: 3000
      })
    },async getTags(){
      let response = await api.post("tags/list");
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        response.data.forEach(function(e){
          this.existing_tags.push({ key: e.tags.substring(0, 100), value: e.tags.substring(0, 100) });
        }.bind(this));
      }            
    },
    async getColumns(){
      var response = await  api.post('admin/mapping_headers/list')
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
      if (response.status == 'success') {
        if (response.data != '') {          
          response.data.data.forEach(function(e){                      
            this.map_headers.push({value:e.column_key,text:e.column});
            //this.filterCriteriaColumns.push({value:e.column_key,text:e.column,disabled:false});
          }.bind(this));                    
        } else {
          this.map_headers = [];
          this.makeToast(`No database headers found.`, 'Alert', 'danger')
        }
      } else
      this.makeToast(`No database headers found.`, 'Alert', 'danger')
    },    
    addFilterCriteria(){
      this.filterCriteria.push({columns:null,text_value:null})
    },
    deleteFilterCriteria(index){
      this.filterCriteria.splice(index, 1)
    },
    addConcateColumn(){
      this.concateColumn.push({columns:[null],name:null})
    },
    deleteConcateColumn(index){
      this.concateColumn.splice(index, 1)
    },
    addColumns(index){        
      this.concateColumn[index].columns.push(null);
    },
    deleteColumn(index,idx){
      this.concateColumn[index].columns.splice(idx, 1)
    },    
    selectedHeaders(index){        
      if(this.selectedHeadersShow.includes(this.map_headers[index]))        { 
        this.selectedHeadersShow.splice(this.selectedHeadersShow.indexOf(this.map_headers[index]),1);
      } else {
        this.selectedHeadersShow.push(this.map_headers[index]);
      }        
    }, 
    async getVendors(){
      let response = await api.post("users/get-user-List",{"type" : "vendor"});
      if(!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status=='success'){
        if(response.data != ''){                    
          response.data.forEach(function(e){                      
            this.vendors.push({value:e.id,text:e.first_name +' '+e.last_name});
          }.bind(this));                      
        }else{
          this.campaigns=[];
          this.makeToast(`Vendor not found.`,'Alert','danger')
        }
      }
    },
    async save(){
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else{   
       if (this.filterCriteria[0].columns === null || this.filterCriteria[0].text_value === null || this.filterCriteria[0].text_value === '') {
        this.makeToast("Please, fill search criteria","Alert","danger",6000);
        return;
      }
      if (this.selectedHeadersShow.length === 0) {
        this.makeToast("Please, select any columns","Alert","danger",6000);
        return;
      }

      this.formField.marketing_event_id = this.$route.params.id;
      this.formField.user_type = 'vendor';  
      this.formField.contact_values = {
        'filter_criteria' :this.filterCriteria,
        'concate_column':(this.concateColumn[0].name !== null?this.concateColumn:[]),
        'selected_column':(this.selectedHeadersShow.length !== 0?this.selectedHeadersShow:[] ),
        'match_with':this.formField.type
      }; 

      let response = await api.post('admin/marketing-event/assign-vendor', this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status=='success'){
        this.makeToast(response.message,'Success','success');
        this.$router.push({name:"List Event"})
      }else{
        for(var error in response.errors){
          this.makeToast(response.errors[error],'Alert','danger');
        }
      }
    }
  }
}
}


